import "../../../constants/index.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
import { require200Status } from "../../utils/response.js";
import { FundingMethodConvertSpec, FundingGroupConvertSpec } from "../../../types/models/funding.specs.js";
function depositMethodEndpoints(builder) {
  return {
    getDepositMethods: builder.query({
      providesTags: ["deposit-methods"],
      query: () => ({
        url: `/member/deposit-methods`,
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec(FundingMethodConvertSpec)
    }),
    getFundingGroups: builder.query({
      providesTags: ["funding-groups"],
      query: ({ query }) => ({
        url: `/member/funding/group/list${parseQs(query)}`,
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec(FundingGroupConvertSpec)
    })
  };
}
export {
  depositMethodEndpoints as default
};
